<template>
    <div class="modal fade1 in" id="modal-default" style="display: block;" :v-show="shwovalueEditCandidate">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" aria-label="Close">
                    <span aria-hidden="true" @click="closeEditCandidate()">×</span></button>
                    <h4>Edit Candidate Profile</h4>
                </div>
                <div class="modal-body">
                    <div class="card-body">
                        <b-form class="register-form" id="resets" v-on:submit.prevent="onSubmitCandidateProfile" novalidate>
                            <div class="col-md-12">
                                <input v-if="Boolean(editoption2)" type="submit" value="Save" style="width: 93px;height: 30px;" class="submit pull-right" name="submit" id="submit" />
                                <button v-if="Boolean(editoption1)" @click="changeedit()" style="width: 93px;height: 30px;font-size: 16px;padding: 2px;" class="btn btn-success pull-right">Edit</button>
                                <div v-if="Boolean(editoption2)">
                                    <button @click="cancel()" style="width: 93px;height: 30px;font-size: 16px;padding: 2px;" class="btn btn-default pull-right mr-2">Cancel</button>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-12">
                                    <label>Name</label>
                                    <b-form-input type="text" v-model.lazy.trim="candidate_name" :disabled="Boolean(editoption)" placeholder="Name*" />
                                </div>
                                <div class="col-md-12 mt-2">
                                    <label>Last Name</label>
                                    <b-form-input type="text" v-model.lazy.trim="candidate_lastname" :disabled="Boolean(editoption)" placeholder="Lastname" />
                                </div>
                                <div class="col-md-12 mt-2">
                                    <label>Email</label>
                                    <b-form-input :class="{'warningBorder' : (candidate_email === '' || candidate_email === null || candidate_email === undefined) , 'dangerBorder' : ((candidate_email === '' || candidate_email === null || candidate_email === undefined) && (candidate_mobile_number === '' || candidate_mobile_number === null || candidate_mobile_number === undefined))}" type="text" v-model.lazy.trim="candidate_email" :disabled="Boolean(editoption)" placeholder="Email" />
                                </div>
                                <div class="col-md-12 mt-2">
                                    <label>Phone</label>
                                    <b-form-input  :class="{'dangerBorder' : (candidate_mobile_number === '' || candidate_mobile_number === null || candidate_mobile_number === undefined)}" type="text" v-model.lazy.trim="candidate_mobile_number" :disabled="Boolean(editoption)" placeholder="Phone No." />
                                </div>
                            </div>
                        </b-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { BaseURL } from '../shared/classes'
export default {
  data () {
    return {
      editoption1: true,
      editoption2: false,
      editoption: true,
      mainurl: '',
      BaseURL: BaseURL,
      candidate_name: '',
      candidate_lastname: '',
      candidate_mobile_number: '',
      candidate_email: ''
    }
  },
  props: [
    'data', 'shwovalueEditCandidate'
  ],
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      this.candidate_name = this.data.candidate_name
      this.candidate_lastname = this.data.candidate_lastname
      this.candidate_mobile_number = this.data.candidate_mobile_number
      this.candidate_email = this.data.candidate_email
    },
    closeEditCandidate (reload = false) {
      var dat = {
        close: false,
        reload: reload
      }
      this.$emit('editCandidate_emit', dat)
    },
    changeedit () {
      // console.log('change')
      this.editoption = false
      this.editoption2 = true
      this.editoption1 = false
    },
    cancel () {
      this.editoption = true
      this.editoption2 = false
      this.editoption1 = true
    },
    onSubmitCandidateProfile () {
      this.mainurl = '/dashboard/edit_upload_candidate'
      var formData = {
        schedule_id: this.data._id,
        candidate_email: this.candidate_email,
        candidate_mobile_number: this.candidate_mobile_number,
        candidate_name: this.candidate_name,
        candidate_lastname: this.candidate_lastname
      }
      axios.post(BaseURL + this.mainurl, {
        formData: formData
      }, this.config).then(response => {
        this.$awn.success('Candidate Details updated successfully')
        this.closeEditCandidate(true)
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.warningBorder{
  border: #fad475 !important;
  border-width: 1px !important;
  border-style: solid !important;
  box-shadow: 1px 1px 3px 0.2px #fad475;
}
.dangerBorder {
  border: rgb(255, 0, 0) !important;
  border-width: 1px !important;
  border-style: solid !important;
  box-shadow: 1px 1px 3px 0.2px rgb(248, 140, 94);
}

</style>
